import { apiUrl } from '../config/api';

const CONSENT_KEY='nido_privacy_choice_v1';
const VISITOR_KEY='nido_analytics_visitor_v1';

const visitorId=()=>{
  let value=localStorage.getItem(VISITOR_KEY);
  if(!value){value=window.crypto?.randomUUID?.()||`${Date.now()}-${Math.random().toString(36).slice(2)}`;localStorage.setItem(VISITOR_KEY,value);}
  return value;
};

export const acquisitionSource=()=>{
  const params=new URLSearchParams(window.location.search);
  const explicit=String(params.get('source')||'').toUpperCase();
  if(['SEARCH','MAP','EDITORIAL','FEATURED','DIRECT','EXTERNAL'].includes(explicit))return explicit;
  if(params.get('campaign'))return 'EDITORIAL';
  try{return document.referrer&&new URL(document.referrer).origin!==window.location.origin?'EXTERNAL':'DIRECT';}catch{return 'DIRECT';}
};

export function trackProductEvent(name,{property,project,metadata,source}={}){
  if(localStorage.getItem(CONSENT_KEY)!=='accepted')return;
  fetch(apiUrl('/analytics/events'),{
    method:'POST',
    keepalive:true,
    credentials:'include',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({name,property,project,metadata,source:source||acquisitionSource(),anonymousId:visitorId(),path:`${window.location.pathname}${window.location.search}`}),
  }).catch(()=>{/* La medición nunca debe afectar la experiencia. */});
}
